<mat-card>
  <mat-card-title>Informações e procedimentos a serem realizados pelo chefe do departamento</mat-card-title>
  <mat-card-content>
    <ol>
      <li>
        Liberar disciplinas do departamento que possua(m) docente(s) atribuído(s), para aceitar inscrições de alunos
        PAADES. O aluno poderá se inscrever em 1(uma) ou mais disciplinas.
      </li>
      <li>
        Aprovar uma única inscrição para aluno PAADES. A disciplina selecionada pelo departamento deverá ser compatível
        com a área de pesquisa do programa de pós-graduação, do pós-graduando e de sua formação.
      </li>
      <li>
        Submeter o plano de atividades assinado pelo docente da disciplina e pelo orientador: ao conselho de
        departamento para aprovação e ao conselho de curso de graduação para ciência. Após submissão dessas instâncias,
        aprovar no sistema.
      </li>
      <li>
        Após as devidas aprovações vincular na oferta de disciplina no SISGRAD para o período letivo o nome do aluno. O
        aluno iniciará o PAADES somente após essas aprovações no plano de atividades.
      </li>
      <li>Consolidar a disciplina referente a aluno PAADES no SISGRAD.</li>
      <li>Homologar o relatório do aluno após a aprovação do mesmo pelo docente responsável pela disciplina.</li>
    </ol>
  </mat-card-content>
</mat-card>

<br />

<mat-card class="info">
  <p>Observações</p>
  <ul>
    <li>Professor substituto poderá supervisonar o PAADES.</li>
    <li>Doutorando (ref. Ofício 02/2022 - Runesp) que ministrar aulas nos cursos de graduação, sob a forma de auxílio
      acadêmico, não poderá supervisionar alunos do PAADES.</li>
  </ul>
</mat-card>
